import gql from 'graphql-tag';

export const GET_CHATS = gql`
  query GetChats($data: SearchChatsInput) {
    getChats(data: $data) {
      ... on GetChats {
        message
        version
        paginationInfo {
          currentPage
          totalPages
          nextPage
          prevPage
          totalRecords
          totalReturnedRecords
          startIndex
          endIndex
        }
        chats {
          id
          account_id
          client_account_id
          appointment_id
          estimate_id
          job_id
          invoice_id
          chatType
          name
          clientAccountName
          clientUserFullName
          serviceProviderAccountName
          serviceProviderUserFullName
          serviceProviderAccount {
            users {
              avatarUrl
              role
              firstName
              lastName
            }
          }
          lastMessageText
          lastMessageDateTime
          lastMessageUserId
          lastMessageUserAccountName
          lastMessageUserFirstName
          lastMessageUserLastName
          lastMessageUserAvatarUrl
          spLastReadDateTime
          spHasUnreadMessages
          spUnreadMessageCount
          clientLastReadDateTime
          clientHasUnreadMessages
          clientUnreadMessageCount
          isArchived
          isArchivedClientAccount
          isArchivedServiceProviderAccount
          createdAt
          updatedAt
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const GET_MESSAGES = gql`
  query GetMessages($data: SearchMessagesInput) {
    getMessages(data: $data) {
      ... on GetMessages {
        message
        version
        paginationInfo {
          currentPage
          totalPages
          nextPage
          prevPage
          totalRecords
          totalReturnedRecords
          startIndex
          endIndex
        }
        messages {
          id
          chat_id
          sender_user_id
          sender_account_id
          recipient_account_id
          estimate_id
          job_id
          invoice_id
          senderFirstName
          senderLastName
          senderAvatarUrl
          senderAccountName
          attachments {
            id
            job_id
            account_id
            creator_user_id
            creatorFullName
            client_account_id
            service_item_id
            estimate_id
            property_id
            note_id
            message_id
            invoice_id
            fileName
            fileSize
            mimeType
            base64
            isInternal
            type
            createdAt
            updatedAt
          }
          text
          isInternal
          isArchived
          createdAt
          updatedAt
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

/**
 * One chat by id, with only the fields that say where it belongs.
 *
 * A message notification carries `chatId` and nothing else about the chat, so
 * the thread's record has to be asked for before the reader can be sent to it.
 */
export const GET_CHAT = gql`
  query GetChat($id: ID!) {
    getChat(id: $id) {
      ... on GetChat {
        chat {
          id
          chatType
          job_id
          estimate_id
          invoice_id
          appointment_id
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const CHAT_DESTINATION_FIELDS = gql`
  fragment ChatDestinationFields on Chat {
    id
    chatType
    job_id
    estimate_id
    invoice_id
    appointment_id
  }
`;
